
const saveProductType = async(name) => {
    try {
        const data = { name : name }
        const response = await axios.post(`/condition/addProductType`, data);
        const message = response.data.message;
        if (message === 'A record already exists.') {
            return {created : false, message: message};
        }
        return {created : true, message: message};
    } catch (error) {
        return {created : false, message: error.response.data.message};
    }
}

const saveCondition = async (cond, cont, desc) => {
    try {
        const id_product_type = cond.id;
        const doc_control = (cont === 1) ? "PO" : "SO";
        const description = desc;
        const data = { id_product_type, doc_control, description }
        
        const response = await axios.post( "/condition/condition", data );

        const create = response.data.data ? true : false;

        return {created : create, message: response.data.message};
    } catch (error) {
        console.log("Error al guardar los datos", error);
        return {created : false, message: error.response.data.message};
    }
};

const saveDetail = async (data) => {
    try {
        const response = await axios.post( "/condition/addDetail", data );
        return {created : true, message: response.data.message};
    } catch (error) {
        console.log("Error al guardar los datos", error);
        return {created : false, message: error.response.data.message};
    }
};

const deleteDetail = async (id) => {
    try {
        const response = await axios.delete(`/conditionResources/${id}`)
        return {deleted : true, message: response.data.message};
    } catch (error) {
        console.log("Error al eliminar los datos", error);
        return {deleted : false, message: error.response.data.message};
    }
};

const deleteDetailProductType = async (id) => {
    try {
        const response = await axios.delete(`/product_type/${id}`);
        return {deleted : true, message: response.data.message};
    } catch (error) {
        console.log("Error al eliminar los datos", error);
        return {deleted : false, message: error.response.data.message};
    }
};

const getDetail = async (id) => {
    try {
        const response = await axios.get(`/product_type/get/${id}`);
        return {data : response.data};
    } catch (error) {
        console.log("Error al obtener los datos", error);
        return {data : null, message: error.response.data.message};
    }
};

const updateDetail = async (id, data) => {
    try {
        const datos = { id, data };
        const response = await axios.put(`/product_type/${id}`, datos);
        return {updated : true, message: response.data.message};
    } catch (error) {
        console.log("Error al actualizar los datos", error);
        return {updated : false, message: error.response.data.message};
    }
};

export { saveCondition, saveDetail, deleteDetail, getDetail, updateDetail, saveProductType, deleteDetailProductType };